import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, FlexProps, Typography } from 'antd';

import AllowIcon from 'assets/images/icons/allow.svg?react';
import ByAgreementIcon from 'assets/images/icons/by-agreement.svg?react';
import ForbiddendIcon from 'assets/images/icons/denied.svg?react';
import { ETrafficConditions, IOfferTraffikType } from 'entities/Offer';

const { Text } = Typography;

interface IOfferTrafficStatusProps extends Omit<FlexProps, 'children'> {
	traffic: IOfferTraffikType;
}

export const OfferTrafficStatus: FC<IOfferTrafficStatusProps> = ({ traffic, ...props }) => {
	const { t } = useTranslation();

	const statuses = {
		[ETrafficConditions.ALLOWED]: {
			icon: <AllowIcon />,
			label: t('Разрешено'),
		},
		[ETrafficConditions.FORBIDDEN]: {
			icon: <ForbiddendIcon />,
			label: t('Запрещено'),
		},
		[ETrafficConditions.BY_AGREEMENT]: {
			icon: <ByAgreementIcon />,
			label: t('По согласованию'),
		},
	};

	return (
		<Flex {...props} gap={4} align="center">
			{statuses?.[traffic.condition]?.icon}
			<Text>{statuses?.[traffic.condition]?.label}</Text>
		</Flex>
	);
};
